<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋內容範本" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </template>
    <template slot="right">
      <el-button @click="$router.push({ name: 'createContentTemplate' })" style="margin-right: 20px;">新增內容範本</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">

      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column prop="Name" label="名稱" min-width="120px">
        </el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="$router.push({ name: 'updateContentTemplate', params: { id: scope.row.ID }})">
              編輯
            </el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
// import moment from 'moment'
import LeftMenu from '@/components/LeftMenu.vue'
import TopHeader from '@/components/TopHeader.vue'

export default {
  components: {
    LeftMenu, TopHeader
  },
  data () {
    return {
      searchTimer: null,
      keyword: '',
      searchedObjs: [],
      tableData: [],
      currentPage: 1,
      isLoading: false
    }
  },
  computed: {
  },
  methods: {
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    delaySearch () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = window.setTimeout(() => {
        this.searchTimer = null
        this.search()
      }, 500)
    },
    search () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
      this.currentPage = 1
      this.alertSearchResult()
    },
    filterObjs () {
      if (!this.keyword && this.status === 'all') {
        this.searchedObjs = this.$store.state.contentTemplate.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        const isNameFit = o => o.Name && o.Name.includes(this.keyword)
        return isNameFit(o)
      }

      this.searchedObjs = this.$store.state.contentTemplate.list.filter(u => {
        return isObjFitKeyword(u)
      })
    },
    alertSearchResult () {
      if (this.searchedObjs.length > 0) {
        this.$message({
          message: `搜尋結果共${this.searchedObjs.length}筆符合條件`,
          duration: 1000
        })
      } else {
        this.$message({
          message: '查無符合條件內容範本',
          duration: 1000
        })
      }
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除此內容範本 ${obj.Name} ?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.contentTemplate.delete(this, obj.ID).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.contentTemplate.list.findIndex(o => o.ID === obj.ID)
          if (idx >= 0) this.$store.state.contentTemplate.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice((this.currentPage - 1) * 20, this.currentPage * 20)
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      })
    }
  },
  created () {
    this.searchedObjs = this.$store.state.contentTemplate.list
    this.tableData = this.searchedObjs.slice(0, 20)
  }
}
</script>
